import _ from 'lodash';
import { AppWindow, WindowGeometry } from '../types';
import { WindowSizes } from '../constants/windowSizes';

export enum Direction {
  Top = 'top',
  Right = 'right',
  Bottom = 'bottom',
  Left = 'left',
  TopRight = 'topRight',
  BottomRight = 'bottomRight',
  BottomLeft = 'bottomLeft',
  TopLeft = 'topLeft',
}

// type IDirection =
//   | 'top'
//   | 'right'
//   | 'bottom'
//   | 'left'
//   | 'topRight'
//   | 'bottomRight'
//   | 'bottomLeft'
//   | 'topLeft';

export const getAdjustedWindowGeometry = (
  window: Pick<AppWindow, 'x' | 'y' | 'width' | 'height' | 'isMaximized'>,
  topSectionSum: number,
  bottomSectionSum: number,
  maxDims: { width: number; height: number }
): WindowGeometry => {
  const originalGeometry: WindowGeometry = {
    x: window.x,
    y: window.y,
    width: window.width,
    height: window.height,
  };

  if (window.isMaximized) {
    return {
      x: 0,
      y: topSectionSum,
      width: maxDims.width,
      height: maxDims.height,
    };
  } else {
    return adjustWindows(
      topSectionSum,
      bottomSectionSum,
      maxDims.width,
      maxDims.height,
      originalGeometry
    );
  }
};

export const adjustWindows = (
  topSectionSum: number,
  bottomSectionSum: number,
  maxWidth: number,
  maxHeight: number,
  geometry: WindowGeometry
) => {
  let { x, y, width, height } = geometry;

  const xMin = WindowSizes.minWidth - width;
  const xMax = window.innerWidth - WindowSizes.minWidth;

  const yMin = topSectionSum;
  const yMax = window.innerHeight - (bottomSectionSum + WindowSizes.minHeight);

  x = Math.max(xMin, Math.min(x, xMax));
  y = Math.max(yMin, Math.min(y, yMax));
  width = Math.max(WindowSizes.minWidth, Math.min(width, maxWidth));
  height = Math.max(WindowSizes.minHeight, Math.min(height, maxHeight));

  return {
    x,
    y,
    width,
    height,
  };
};

export const getWindowGeometryOnResize = (
  direction: Direction,
  x: number,
  y: number,
  geometry: WindowGeometry
): WindowGeometry => {
  x = Math.max(0, x);

  const {
    x: windowX,
    y: windowY,
    width: windowWidth,
    height: windowHeight,
  } = geometry;
  let newX = windowX;
  let newY = windowY;
  let newWidth = windowWidth;
  let newHeight = windowHeight;

  switch (direction) {
    case Direction.Top:
      newY = y;
      newHeight = windowHeight - (newY - windowY);
      break;
    case Direction.Right:
      newWidth = windowWidth + (x - (windowX + windowWidth));
      break;
    case Direction.Bottom:
      newHeight = windowHeight + (y - (windowY + windowHeight));
      break;
    case Direction.Left:
      newX = x;
      newWidth = windowWidth - (newX - windowX);
      break;
    case Direction.TopLeft:
      newY = y;
      newHeight = windowHeight - (newY - windowY);
      newX = x;
      newWidth = windowWidth - (newX - windowX);
      break;
    case Direction.TopRight:
      newY = y;
      newHeight = windowHeight - (newY - windowY);
      newWidth = windowWidth + (x - (windowX + windowWidth));
      break;
    case Direction.BottomLeft:
      newHeight = windowHeight + (y - (windowY + windowHeight));
      newX = x;
      newWidth = windowWidth - (newX - windowX);
      break;
    case Direction.BottomRight:
      newHeight = windowHeight + (y - (windowY + windowHeight));
      newWidth = windowWidth + (x - (windowX + windowWidth));
      break;
    default:
  }

  return {
    x: newX,
    y: newY,
    width: newWidth,
    height: newHeight,
  };
};

export const adjustWindowOnResize = (
  topSectionSum: number,
  bottomSectionSum: number,
  maxWidth: number,
  maxHeight: number,
  oldGeometry: WindowGeometry,
  newGeometry: WindowGeometry
) => {
  // const xMin = WindowSizes.minWidth - newGeometry.width;
  const xMax = window.innerWidth - WindowSizes.minWidth;

  const yMin = topSectionSum;
  const yMax = window.innerHeight - (bottomSectionSum + WindowSizes.minHeight);

  if (newGeometry.y < yMin) {
    newGeometry.y = yMin;
    newGeometry.height = oldGeometry.y + oldGeometry.height - yMin;
  } else if (newGeometry.y > yMax) {
    newGeometry.y = yMax;
    newGeometry.height = oldGeometry.height;
  }

  if (newGeometry.x + newGeometry.width < WindowSizes.minWidth) {
    newGeometry.width = Math.abs(oldGeometry.x) + WindowSizes.minWidth;
    // newGeometry.width = oldGeometry.width
    // newGeometry.width = oldGeometry.x + oldGeometry.height - WindowSizes.minWidth
    // newGeometry.x
  } else if (newGeometry.x > xMax) {
    newGeometry.x = xMax;
    newGeometry.width = oldGeometry.width;
  }

  // if (newGeometry.x < xMin) {
  //   newGeometry.x = xMin;
  //   // newGeometry.width = oldGeometry.width
  //   newGeometry.width = oldGeometry.x + oldGeometry.width - xMin;
  // } else

  newGeometry.width = Math.max(
    WindowSizes.minWidth,
    Math.min(newGeometry.width, maxWidth)
  );
  newGeometry.height = Math.max(
    WindowSizes.minHeight,
    Math.min(newGeometry.height, maxHeight)
  );

  return newGeometry;
};

// export const adjustWindowForResize= (
//   dir: IDirection,
//   x: number,
//   y: number,
//   geometry: WindowGeometry
// ) => {
//   const {
//     x: windowX,
//     y: windowY,
//     width: windowWidth,
//     height: windowHeight,
//   } = geometry;
//   let newX = windowX,
//     newY = windowY,
//     newWidth = windowWidth,
//     newHeight = windowHeight;
//   let changeInPos = 0;

//   // console.log('linePos', linePos);
//   switch (dir) {
//     case Direction.Top:
//       newY = y;
//       changeInPos = newY - windowY;
//       newHeight = windowHeight - changeInPos;
//       break;
//     case Direction.Right:
//       changeInPos = x - (windowX + windowWidth);
//       newWidth = windowWidth + changeInPos;
//       break;
//     case Direction.Bottom:
//       changeInPos = y - (windowY + windowHeight);
//       newHeight = windowHeight + changeInPos;
//       break;
//     case Direction.Left:
//       newX = x;
//       changeInPos = newX - windowX;
//       newWidth = windowWidth - changeInPos;
//       break;
//     case Direction.TopLeft:
//       newY = y;
//       changeInPos = newY - windowY;
//       newHeight = windowHeight - changeInPos;

//       newX = x;
//       changeInPos = newX - windowX;
//       newWidth = windowWidth - changeInPos;
//       break;
//     case Direction.TopRight:
//       newY = y;
//       changeInPos = newY - windowY;
//       newHeight = windowHeight - changeInPos;

//       changeInPos = x - (windowX + windowWidth);
//       newWidth = windowWidth + changeInPos;
//       break;
//     case Direction.BottomLeft:
//       changeInPos = y - (windowY + windowHeight);
//       newHeight = windowHeight + changeInPos;

//       newX = x;
//       changeInPos = newX - windowX;
//       newWidth = windowWidth - changeInPos;
//       break;
//     case Direction.BottomRight:
//       changeInPos = y - (windowY + windowHeight);
//       newHeight = windowHeight + changeInPos;

//       changeInPos = x - (windowX + windowWidth);
//       newWidth = windowWidth + changeInPos;
//       break;
//     default:
//   }

//   // onResize(newX, newY, newWidth, newHeight);

//   return {
//     x: newX,
//     y: newY,
//     width: newWidth,
//     height: newHeight,
//   };
// };
